import { CloseIcon, Tab } from 'components';
import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { SearchTabContainer } from './Search.style';
import { PostArrowBack } from 'pages/home/Home.style';
import People from './People';
import PostList from 'pages/home/PostList';
import Jobs from './Jobs';
import BusinessHub from './BusinessHub';
import { useTranslation } from 'react-i18next';

const TAB_MAP = {
  people: 0,
  posts: 1,
  job: 2,
  'business-hub': 3,
};

const TABS_REVERSE = Object.fromEntries(
  Object.entries(TAB_MAP).map(([k, v]) => [v, k])
);

export default function Search() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const keyword = query.get('keyword');

  const { tabname } = useParams();
  const [activeKey, setActiveKey] = useState(0);

  const tabNameLower = tabname?.toLowerCase();

  const TABS_DISPLAY_LABELS = {
    people: t('HomePage.People'),
    posts: t('HomePage.posts'),
    job: t('HomePage.Job'),
    'business-hub': t('HomePage.BusinessHub'),
  };

  useEffect(() => {
    if (tabNameLower && Object.prototype.hasOwnProperty.call(TAB_MAP, tabNameLower)) {
      setActiveKey(TAB_MAP[tabNameLower]);
    } else {
      setActiveKey(0);
    }
  }, [tabNameLower]);

  const RenderContentItems = (type) => {
    switch (Number(type)) {
      case 0:
        return <People key={keyword} keyword={keyword} />;
      case 1:
        return <PostList view="search" keyword={keyword} />;
      case 2:
        return <Jobs keyword={keyword} />;
      case 3:
        return <BusinessHub keyword={keyword} />;
      default:
        return null;
    }
  };

  const tabList = useMemo(
    () =>
      Object.entries(TAB_MAP).map(([routeName, index]) => ({
        label: TABS_DISPLAY_LABELS[routeName],
        value: index,
        content: RenderContentItems(index),
      })),
    [keyword]
  );

  const handleTabChangePath = (index) => {
    const routeName = TABS_REVERSE[index] || 'people';
    const safeKeyword = encodeURIComponent(keyword);
    navigate(`../search/${routeName}?keyword=${safeKeyword}`, { replace: true });
  };

  return (
    <SearchTabContainer>
      <PostArrowBack className="post-back">
        <CloseIcon iconType="back" onClick={() => navigate(-1)} />
        <div className="search-for">{t('HomePage.SearchFor')} : {keyword}</div>
      </PostArrowBack>
      <Tab
        tabList={tabList}
        handleTabChange={(key) => {
          setActiveKey(key);
          handleTabChangePath(key);
        }}
        callbackTabIndex={() => activeKey}
        activeKey={activeKey}
        keyChange={true}
        tabCustomcss="searchTab"
      />
    </SearchTabContainer>
  );
}
